import {
  Alert,
  AlertTitle,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from "@mui/material";

import { useEffect, useState } from "react";
import { personOrgSearch } from "../../services/shared.service";
import {
  isEmptyArray,
  isNullUndefined,
  maskPhoneNumber,
  titleCase,
} from "../../util/util";
import {
  getIdTypes,
  getSystemOrganizationOptions,
} from "../../services/list.service";
import { ResponsiveRow } from "../../constants/layout.constants";
import ModalContainerModule from "../modules/modalContainer";
import {
  ColumnContainer,
  DetailsColumn,
  DetailsLabel,
  DetailsRow,
  DetailsText,
  ModalAcceptButton,
  ModalCancelButton,
} from "../../constants/component.constants";
import MUIAutoCompleteForm from "../inputs/MUIautoCompleteForm";
import { Box } from "@mui/system";
import { fetchOrganization, fetchOrganizationSecure } from "../../services/organisation.service";
import { useSelector } from "react-redux";
import AddNewUser from "./addNewUser.js";

/**
 *Required props are:
 - showPersonOrgModal: True or false to show or hide modal respectively.
 - handlePersonOrgClose: Function to close the modal ie set showTerminateModal to false.
 - handlePersonOrgSelect: Function that handles when searched for user is found and selected.
 - showAddNewUserForm: The state or task that displays form to add a user in the event they are not found upon search.
 - showAddNewOrgForm: The state or task that displays form to add an organisation in the event it is not found upon search.
 * Optional props are:
 - contractType : The contract type is optional and if present can cause special behaviour
 */

export default function PersonOrgSearch(props) {
  const [idTypeSearch, setIdType] = useState("");
  const [idNoSearch, setIdNo] = useState("");
  const [companySearch, setCompanySearch] = useState("");
  const [searchBy, setSearchBy] = useState("");
  const [individual, setIndividual] = useState(false);
  const [company, setCompany] = useState(false);
  const [noFoundUser, setNoFoundUser] = useState(false);
  const [alreadySubscribed, setAlreadySubscribed] = useState(false);
  const [foundUser, setFoundUser] = useState([]);
  const [idTypeOptions, setIdTypeOptions] = useState([]);
  const [systemOrganizationOptions, setSystemOrganizationOptions] = useState(
    [],
  );
  const [selectedSysOrganization, setSelectedSysOrganization] = useState({
    label: "--",
    value: "--",
  });
  const [startCompanySearch, setStartCompanySearch] = useState(false);
  const [formStage, setFormStage] = useState(1);
  const [editUserModal, setEditUserModal] = useState(false);
  const [personToEdit, setPersonToEdit] = useState(null);

  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const isProxy = useSelector((state) => state?.auth?.user?.isProxy);

  useEffect(() => {
    getIdTypes()
      .then((idTypes) => setIdTypeOptions(idTypes))
      .catch((error) => {
        console.error("getIdTypes Error: ", error);
      });

      // get system organizations
      getSystemOrganizationOptions()
        .then((response) =>
          setSystemOrganizationOptions(response),
        );

    return () => {
      setFormStage(1);
    };
  }, []);

  function onTextChange(searchText) {
    const id = searchText.target.id;
    const value = searchText.target.value;
    if (id === "idNoSearch") {
      setIdNo(value);
    }
    if (id === "companySearch") {
      setCompanySearch(value);
    }
  }

  function handleIdTypeChange(event) {
    let value = event.target.value;
    setIdType(value);
  }

  function onRadioChange(radio) {
    const value = radio.target.value;
    if (radio) {
      if (value === "Individual") {
        setIndividual(true);
        setCompany(false);
        setSearchBy(value);
      }
      if (value === "Company") {
        setCompany(true);
        setIndividual(false);
        setSearchBy(value);
      }
    }
  }

  function searchPersonOrg() {
    setFormStage(2);
    let data = {
      searchType: searchBy,
      idType: idTypeSearch,
      idNumber: idNoSearch,
      contractType: isNullUndefined(props.contractType)
        ? null
        : props.contractType,
      organizationName: companySearch,
    };
    personOrgSearch(data)
      .then((response) => {
        setAlreadySubscribed(false);
        setNoFoundUser(false);
        if (
          props.contractType === "subscription" &&
          response.length === 1 &&
          response[0].searchStatus === "already_subscriber"
        ) {
          setAlreadySubscribed(true);
          setFoundUser([]);
        } else if (isEmptyArray(response)) {
          setNoFoundUser(true);
          setFoundUser([]);
        } else {
          setFoundUser(response);
        }
      })
      .catch((error) => {
        console.error("PersonOrg Error: ", error);
      });
  }

  function addNewOrgBySearch() {
    setStartCompanySearch(true);
  }

  function showAddUserForm() {
    if (individual) {
      props.showAddNewUserForm(idNoSearch, idTypeSearch);
    } else {
      props.showAddNewOrgForm(companySearch);
    }

    setSearchBy("");
    setIndividual(false);
    setCompany(false);
    setNoFoundUser(false);
    setAlreadySubscribed(false);
    setIdNo("");
    setIdType("");
    setCompanySearch("");
    setFormStage(1);
    // props.handlePersonOrgClose?.()
  }

  function finishPersonOrgSelect(obj) {
    setIndividual(false);
    setCompany(false);
    setIdType("");
    setIdNo("");
    setCompanySearch("");
    setFoundUser([]);
    setNoFoundUser(false);
    setAlreadySubscribed(false);
    setFormStage(1);
    setEditUserModal(false);
    setPersonToEdit(null);
    setSearchBy("")
    setSelectedSysOrganization({
      label: "--",
      value: "--",
    })
    props.handlePersonOrgSelect(obj);
  }

  function selectPersonOrg(result) {
    let obj = { ...result };

    if (individual === true) {
      obj.type = "Individual";
      if (obj.id && !String(obj.id).includes("_")) {
        obj.id = `${obj.id}_P`;
      }
      setPersonToEdit(obj);
      setEditUserModal(true);
      return;
    }

    obj.type = "Company";
    if (obj.id && !String(obj.id).includes("_")) {
      obj.id = `${obj.id}_O`;
    }
    finishPersonOrgSelect(obj);
  }

  function handleEditUserSave(editedPerson) {
    finishPersonOrgSelect(editedPerson);
  }

  function handleEditUserClose() {
    setEditUserModal(false);
    setPersonToEdit(null);
    setSearchBy("")
    setStartCompanySearch( false)
  }

  function modalClose() {
    setIndividual(false);
    setCompany(false);
    setIdType("");
    setIdNo("");
    setCompanySearch("");
    setStartCompanySearch(false)
    setFoundUser([]);
    setNoFoundUser(false);
    setAlreadySubscribed(false);
    setFormStage(1);
    setEditUserModal(false);
    setPersonToEdit(null);
    setSearchBy("")
    props.handlePersonOrgClose?.();
  }

  function returnToSearchForm() {
    setAlreadySubscribed(false);
    setFormStage(1);
  }

  function handleSelectSysOrganization(selection) {
    if (selection === null) {
      setSelectedSysOrganization({
        label: "--",
        value: "--",
      });
    } else {
      setSelectedSysOrganization(selection);
    }
  }

  function proceedWithSelectedSysOrganization() {
    if (props.contractType === "vendor") {
      selectPersonOrg({
        id: selectedSysOrganization.value,
        name: selectedSysOrganization.label,
        type: "Company",
      });
      return;
    }
    if (isLoggedIn && isProxy) {
      fetchOrganizationSecure(selectedSysOrganization.value).then((organization) => {
        selectPersonOrg(organization);
      });
    } else {
      fetchOrganization(selectedSysOrganization.value).then((organization) => {
        selectPersonOrg(organization);
      });
    }
  }

  useEffect(() => {
    return () => {
      setFormStage(1);
    };
  }, []);

  return (
    <>
    <ModalContainerModule
      size="specialPersonOrgSearchModal"
      openModal={props.showPersonOrgModal}
      modalTitle="Individual/Company Search"
      cancel={modalClose}
    >
      <ResponsiveRow
        sx={{
          flexDirection: "column",
          flexWrap: "nowrap",

          width: "100%",
          height: "100%",

          justifyContent: "flex-start",
          alignItems: "flex-start",
          padding: 0,
        }}
      >
        {formStage === 1 ? (
          <ResponsiveRow
            sx={{
              flexDirection: "column",
              flexWrap: "nowrap",

              width: "100%",
              height: "100%",

              justifyContent: "flex-start",
              alignItems: "flex-start",

              overflowY: "auto",
              padding: 0,
              marginBottom: "0px",
            }}
          >
            <Alert
              sx={{
                width: "100%",
                height: "auto",
                padding: "10px 20px",
              }}
              severity="info"
            >
              <AlertTitle color="info">
                Please select a user type below.
              </AlertTitle>
              <Typography variant="body2" sx={{ width: "100%" }}>
                Select <strong>Individual</strong> to search for individuals by
                ID type and number and <strong> Company</strong> to find
                companies based on their name
              </Typography>
            </Alert>
            <ResponsiveRow
              component="div"
              className="ui toggle checkbox"
              sx={{
                width: "100%",
                height: "auto",

                flexWrap: "nowrap",
                padding: "10px 20px",
                marginBottom: 0,
              }}
            >
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="use-radio-group"
                value={searchBy}
              >
                <FormControlLabel
                  name="radio"
                  control={<Radio value="Individual" onClick={onRadioChange} />}
                  label="Individual"
                />
                <FormControlLabel
                  name="radio"
                  control={<Radio value="Company" onChange={onRadioChange} />}
                  label="Company"
                />
              </RadioGroup>
            </ResponsiveRow>

            <ResponsiveRow
              sx={{
                width: "100%",
                height: individual && company ? "100%" : "100%",

                padding: 0,
                marginBottom: "10px",

                justifyContent: "flex-start",
                alignItems: "flex-start",

                flexWrap: "nowrap",
              }}
            >
              {individual ? (
                <>
                  <FormControl
                    sx={{
                      width: { xs: "100%", lg: "50%" },
                      marginBottom: "10px",
                    }}
                  >
                    <InputLabel>ID Type</InputLabel>
                    <Select
                      label="ID Type"
                      sx={{ width: { xs: "100%", md: "90%" } }}
                      id={"idTypeSearch"}
                      value={idTypeSearch}
                      onChange={(event) => handleIdTypeChange(event)}
                    >
                      {idTypeOptions && idTypeOptions.length > 0 ? (
                        idTypeOptions.map(function (idType) {
                          return (
                            <MenuItem key={idType.value} value={idType.value}>
                              {idType.label}
                            </MenuItem>
                          );
                        }, this)
                      ) : (
                        <MenuItem sx={{ width: "100%" }}>
                          No Results Found
                        </MenuItem>
                      )}
                    </Select>
                  </FormControl>

                  <FormControl
                    sx={{
                      width: { xs: "100%", lg: "50%" },
                      marginBottom: "10px",
                    }}
                  >
                    <InputLabel>ID Number</InputLabel>
                    <OutlinedInput
                      label="ID Number"
                      sx={{ width: { xs: "100%", md: "90%" } }}
                      id={"idNoSearch"}
                      value={idNoSearch}
                      onChange={(searchText) => onTextChange(searchText)}
                    />
                  </FormControl>
                </>
              ) : company && !startCompanySearch ? (
                <Box>
                  <Alert
                    sx={{
                      width: "100%",
                      height: "auto",

                      overflow: "hidden",
                      margin: 0,
                    }}
                    severity="info"
                  >
                    <AlertTitle color="info">{titleCase(props?.contractType)} Organization</AlertTitle>
                    Select a system organization. If your preferred organization is not listed, you can add
                    the organization by clicking "Add Organization"
                  </Alert>

                  <ResponsiveRow>
                    <FormControl sx={{ width: { xs: "100%", lg: "65%" } }}>
                      <MUIAutoCompleteForm
                        itemsData={systemOrganizationOptions}
                        label="System Organization"
                        updateSelected={handleSelectSysOrganization}
                        currentlySelected={selectedSysOrganization}
                        menuId="systemOrganization"
                        width="100%"
                        emptyMessage="No system vendors to show"
                      />
                    </FormControl>
                    {selectedSysOrganization.value === "--" && (
                      <ModalAcceptButton
                        onClick={addNewOrgBySearch}
                        sx={{
                          width: { xs: "100%", lg: "200px" },
                          height: "50px",
                        }}
                      >
                        Add Organization
                      </ModalAcceptButton>
                    )}
                  </ResponsiveRow>
                </Box>
              ) : company && startCompanySearch ? (
                <FormControl sx={{ width: { xs: "100%", lg: "75%" } }}>
                  <InputLabel>Company Name</InputLabel>
                  <OutlinedInput
                    label="Company Name"
                    sx={{ width: { xs: "100%", md: "90%" } }}
                    id={"companySearch"}
                    value={companySearch}
                    onChange={(searchText) => onTextChange(searchText)}
                  />
                </FormControl>
              ) : null}
            </ResponsiveRow>
            <ResponsiveRow
              sx={{
                justifyContent: "flex-end",
                alignItems: "flex-end",
                width: "100%",
                height: "auto",
                marginBottom: "10px",
              }}
            >
              {company && selectedSysOrganization && !startCompanySearch ? (
                <ModalAcceptButton
                  onClick={proceedWithSelectedSysOrganization}
                  disabled={selectedSysOrganization.value === "--"}
                  sx={{
                    width: { xs: "100%", lg: "200px" },
                    height: "50px",
                  }}
                >
                  Proceed
                </ModalAcceptButton>
              ) : (
                <ModalAcceptButton
                  onClick={searchPersonOrg}
                  disabled={
                    !(
                      (idTypeSearch !== "" && idNoSearch !== "") ||
                      companySearch !== ""
                    )
                  }
                  sx={{
                    width: { xs: "100%", lg: "200px" },
                    height: "50px",
                  }}
                >
                  Search
                </ModalAcceptButton>
              )}
            </ResponsiveRow>
          </ResponsiveRow>
        ) : (
          <ResponsiveRow
            sx={{
              width: "100%",
              height: "auto",

              justifyContent: "flex-start",
              alignItems: "flex-start",
            }}
          >
            <Typography
              variant="h5"
              color="primary.dark"
              textAlign="start"
              sx={{ width: "100%", marginBottom: "10px" }}
            >
              Search Results ({foundUser.length})
            </Typography>
            <ResponsiveRow
              sx={{
                flexDirection: { xs: "column", lg: "row" },
                flexWrap: { xs: "nowrap", lg: "wrap" },

                width: "100%",
                height: "auto",

                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              {foundUser &&
                foundUser.length > 0 &&
                foundUser.map(function (customer, i) {
                  return (
                    <ColumnContainer
                      key={customer.id}
                      item
                      sx={{
                        width: "100%",
                        height: "auto",

                        borderRadius: "10px",
                        backgroundColor: "#efefef",

                        "&:hover": {
                          backgroundColor: "#dfdfdf",
                        },
                        margin: "5px",
                        padding: "10px",
                      }}
                    >
                      <Typography
                        fontWeight={800}
                        variant="h6"
                        color="primary.dark"
                        sx={{
                          textAlign: "start",
                        }}
                      >
                        {`Confirm Details`}
                      </Typography>
                      <ResponsiveRow
                        sx={{ flexDirection: { xs: "column", md: "row" } }}
                      >
                        <DetailsColumn
                          sx={{
                            width: { xs: "100%", md: "50%" },
                            paddingBottom: { xs: "0px", md: "10px" },
                          }}
                        >
                          <DetailsRow>
                            <DetailsLabel>Name:</DetailsLabel>
                            <DetailsText>{customer.name ?? "N/A"}</DetailsText>
                          </DetailsRow>
                          <DetailsRow>
                            <DetailsLabel>Email:</DetailsLabel>
                            <DetailsText sx={{ wordBreak: "break-word" }}>
                              {customer.email ?? "N/A"}
                            </DetailsText>
                          </DetailsRow>
                          <DetailsRow>
                            <DetailsLabel>Phone:</DetailsLabel>
                            <DetailsText>
                              {maskPhoneNumber(customer.mobilePhone) ?? "N/A"}
                            </DetailsText>
                          </DetailsRow>
                        </DetailsColumn>
                        {company && (
                          <DetailsColumn
                            sx={{
                              width: { xs: "100%", md: "50%" },
                              paddingTop: { xs: "0px", md: "10px" },
                            }}
                          >
                            <DetailsRow>
                              <DetailsLabel>Description:</DetailsLabel>
                              <DetailsText>
                                {customer.description ?? "N/A"}
                              </DetailsText>
                            </DetailsRow>
                          </DetailsColumn>
                        )}
                        {individual && (
                          <DetailsColumn
                            sx={{
                              width: { xs: "100%", md: "50%" },
                              paddingTop: { xs: "0px", md: "10px" },
                            }}
                          >
                            <DetailsRow>
                              <DetailsLabel>ID Type:</DetailsLabel>
                              <DetailsText>
                                {customer.idType ?? "N/A"}
                              </DetailsText>
                            </DetailsRow>
                            <DetailsRow>
                              <DetailsLabel>ID:</DetailsLabel>
                              <DetailsText>
                                {customer.idNumber ?? "N/A"}
                              </DetailsText>
                            </DetailsRow>
                          </DetailsColumn>
                        )}
                      </ResponsiveRow>
                      <ModalAcceptButton
                        onClick={() => {
                          setStartCompanySearch(false)
                          selectPersonOrg(customer)
                        }}
                        sx={{ width: "100px" }}
                      >
                        Confirm
                      </ModalAcceptButton>
                    </ColumnContainer>
                  );
                })}
            </ResponsiveRow>
            {noFoundUser && (
              <ResponsiveRow
                sx={{
                  flexDirection: "column",
                  flexWrap: "nowrap",

                  width: "100%",
                  height: "auto",

                  justifyContent: "flex-start",
                  alignItems: "flex-start",

                  margin: 0,
                  padding: 0,
                }}
              >
                <Alert
                  sx={{
                    width: "100%",
                    height: "auto",

                    overflow: "hidden",
                    margin: 0,
                  }}
                  severity="error"
                >
                  <AlertTitle color="error">
                    No {individual ? "Individuals" : "Companies"} found
                  </AlertTitle>
                  <Typography sx={{ width: "100%" }}>
                    There were no {individual ? "individuals" : "companies"}{" "}
                    found with that {individual ? "ID number" : "Company Name"}.
                  </Typography>
                  <Typography sx={{ width: "100%" }}>
                    Would you like to create a new{" "}
                    {individual ? "Individual" : "Company"}?
                  </Typography>
                  <ResponsiveRow
                    sx={{
                      width: "100%",
                      justifyContent: "flex-end",
                      height: "auto",
                    }}
                  >
                    <ModalAcceptButton
                      onClick={showAddUserForm}
                      sx={{ width: { xs: "100%", lg: "100px" } }}
                    >
                      Yes
                    </ModalAcceptButton>
                    <ModalCancelButton
                      onClick={() => {
                        setNoFoundUser(false);
                        setFormStage(1);
                      }}
                      sx={{ width: { xs: "100%", lg: "100px" } }}
                    >
                      No
                    </ModalCancelButton>
                  </ResponsiveRow>
                </Alert>
              </ResponsiveRow>
            )}
            {alreadySubscribed && (
              <ResponsiveRow
                sx={{
                  flexDirection: "column",
                  flexWrap: "nowrap",
                  width: "100%",
                  height: "auto",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                  margin: 0,
                  padding: 0,
                }}
              >
                <Alert
                  sx={{
                    width: "100%",
                    height: "auto",
                    overflow: "hidden",
                    margin: 0,
                  }}
                  severity="error"
                >
                  <AlertTitle color="error">
                    {individual
                      ? "Individual already has a subscription"
                      : "Company already has a subscription"}
                  </AlertTitle>
                  <Typography sx={{ width: "100%" }}>
                    {individual
                      ? "A person with this ID number already exists and has a subscription. You cannot create a new individual record. Find and manage their existing subscription instead."
                      : "A company with this name already exists and has a subscription. You cannot create a new company record. Find and manage their existing subscription instead."}
                  </Typography>
                  <ResponsiveRow
                    sx={{
                      width: "100%",
                      justifyContent: "flex-end",
                      height: "auto",
                    }}
                  >
                    <ModalCancelButton
                      onClick={returnToSearchForm}
                      sx={{ width: { xs: "100%", lg: "100px" } }}
                    >
                      No
                    </ModalCancelButton>
                  </ResponsiveRow>
                </Alert>
              </ResponsiveRow>
            )}
          </ResponsiveRow>
        )}
      </ResponsiveRow>
    </ModalContainerModule>
    {editUserModal && (
      <AddNewUser
        openModal={editUserModal}
        closeModal={handleEditUserClose}
        selectedPerson={personToEdit}
        task="Edit"
        saveUser={handleEditUserSave}
        manageUsers={false}
      />
    )}
    </>
  );
}
